import { Input, message } from "antd";
import { Button1, Select } from "../index";
import TextArea from "antd/es/input/TextArea";
import infoIcon from "../../assets/icons/inforound-icon.png";
import copyIcon from "../../assets/icons/copy-07.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { moneyRequestsApi } from "../../api/endpoints";

const CURRENCIES = [
  { name: "Australian Dollar (AUD)", value: "AUD" },
  { name: "US Dollar (USD)", value: "USD" },
  { name: "Euro (EUR)", value: "EUR" },
  { name: "British Pound (GBP)", value: "GBP" },
  { name: "Pakistani Rupee (PKR)", value: "PKR" },
];

const RequestMoneyCreate = ({ sourceAccount }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [createdLink, setCreatedLink] = useState("");

  const [form, setForm] = useState({
    amount: "",
    currency: sourceAccount?.currency || "AUD",
    note: "",
  });

  const update = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const handleCreateRequest = async () => {
    setError(null);
    if (!form.amount || Number(form.amount) <= 0) {
      setError("Enter a valid amount");
      return;
    }
    setLoading(true);
    try {
      const resp = await moneyRequestsApi.create({
        accountId: sourceAccount?.id,
        amount: Number(form.amount),
        currency: form.currency,
        note: form.note || undefined,
      });
      message.success("Request created successfully");
      const link =
        resp?.payLink ||
        `${window.location.origin}/pay/${resp?.id || resp?.token || ""}`;
      setCreatedLink(link);
      navigate("/request-money-summary", { state: { request: resp } });
    } catch (e) {
      setError(
        e.response?.data?.error ||
          e.response?.data?.details?.[0]?.message ||
          e.message ||
          "Failed to create request"
      );
    } finally {
      setLoading(false);
    }
  };

  const availableBalance = sourceAccount
    ? `${Number(sourceAccount.availableBalance).toLocaleString()} ${
        sourceAccount.currency
      }`
    : "0.00";

  return (
    <>
      <div className="row border justify-content-between gap-4 rounded-3 p-3 mt-3 mx-1 ">
        <div className="col-lg-5">
          <div className="d-flex flex-column gap-3">
            <div className="d-flex flex-column gap-2">
              <span className="fs-5 fw-medium">
                Tell us what your request is for
              </span>
              <span className="fs12px" style={{ color: "#7D7D7D" }}>
                We'll create a link someone can use to pay you
              </span>
            </div>

            <div className="d-flex flex-column gap-2">
              <div className="d-flex gap-3 ">
                <div className=" d-flex flex-column gap-2 ">
                  <label className="fs12px">You receive</label>
                  <Input
                    className="p-3 w-100"
                    placeholder="0.00"
                    value={form.amount}
                    onChange={(e) => update("amount", e.target.value)}
                  />
                </div>
                <div className="d-flex flex-column gap-2 w-75">
                  <label className="fs12px">Currency</label>
                  <Select
                    value={form.currency}
                    options={CURRENCIES}
                    defaultValue="Currency"
                    className="p-3 "
                    selectStyle={{ width: "100%" }}
                    onChange={(e) => update("currency", e.target.value)}
                  />
                </div>
              </div>
              <span className="fs12px" style={{ color: "#7D7D7D" }}>
                Available Balance :{" "}
                <span className="text-black">{availableBalance}</span>
              </span>
            </div>

            <div className="d-flex flex-column gap-2">
              <label className="fs12px">Add a note(optional)</label>
              <TextArea
                className="p-3 rounded-3"
                placeholder="Type a Note"
                autoSize={{ minRows: 3, maxRows: 5 }}
                value={form.note}
                onChange={(e) => update("note", e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="col-lg-6">
          <div className="d-flex flex-column gap-3">
            <span className="fs-5 fw-medium">Share your request link</span>

            <div className="d-flex flex-column gap-2">
              <label className="fs12px">Generate link</label>
              <Input
                suffix={
                  <img
                    src={copyIcon}
                    alt="copy"
                    className="cursor-pointer"
                    onClick={() => {
                      if (createdLink) {
                        navigator.clipboard?.writeText(createdLink);
                        message.success("Copied");
                      }
                    }}
                  />
                }
                value={createdLink || "Click Done to generate link"}
                className="p-3"
                readOnly
              />
            </div>

            <Button1
              buttonName={"or Generate QR Code"}
              className={"btn-dark  align-self-lg-start"}
              disabled={!createdLink}
            />
          </div>
        </div>

        <div className="px-3 py-0">
          <div
            className="rounded-4 d-flex gap-3  p-3  align-items-center"
            style={{ backgroundColor: "#F7F7F7" }}
          >
            <div>
              <img src={infoIcon} alt="circle" />
            </div>
            <div className="d-flex flex-column gap-1">
              <span className="fw-medium">Please Note!</span>
              <span
                className="fs14px fw-medium pe-3"
                style={{ color: "#4A4A4A" }}
              >
                Give this link to the person paying you. it'll keep working
                until they pay you or when it expires.
              </span>
            </div>
          </div>
        </div>

        {error && (
          <div className="px-3">
            <span className="fs12px" style={{ color: "#FC555B" }}>
              {error}
            </span>
          </div>
        )}

        <div className="d-flex justify-content-md-end justify-content-center p-2 gap-3 flex-md-nowrap flex-wrap">
          <Button1 buttonName={"Give feedback  "} className={"border"} />
          <Button1
            buttonName={loading ? "Saving..." : "Done"}
            className={"btn-outline-success px-5 "}
            onClick={handleCreateRequest}
            disabled={loading}
          />
          <Button1
            buttonName={"Share Link"}
            className="btn-dark px-4  "
            disabled={!createdLink}
            onClick={() => {
              if (createdLink) {
                navigator.clipboard?.writeText(createdLink);
                message.success("Link copied");
              }
            }}
          />
        </div>
      </div>
    </>
  );
};

export default RequestMoneyCreate;
